export const WhiteCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 11.7667C23.5 17.9799 18.3606 23.0333 12 23.0333C5.63942 23.0333 0.5 17.9799 0.5 11.7667C0.5 5.55347 5.63942 0.5 12 0.5C18.3606 0.5 23.5 5.55347 23.5 11.7667Z"
      stroke="white"
    />
  </svg>
);

export const OrrangeCircle = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#F2994A" />
    <path
      d="M17.8243 7.18613C17.59 6.93796 17.2101 6.93796 16.9757 7.18613L9.78737 14.7994L7.02428 11.873C6.78997 11.6248 6.4101 11.6248 6.17575 11.873C5.94142 12.1211 5.94142 12.5235 6.17575 12.7716L9.3631 16.1473C9.59734 16.3954 9.97749 16.3953 10.2116 16.1473L17.8243 8.0848C18.0586 7.83665 18.0586 7.43431 17.8243 7.18613Z"
      fill="white"
    />
  </svg>
);
